import axios from "axios";
import { Config } from "../../../core/config/config";


const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/report/power-bi`;

export const powerBiservice = {
    getSalesPerformanceReport: async function () {
        return axios.get(`${GATEWAY_URL}/sales-performance`)
        .then((response) => {
            return response.data;
        });
    },
    newGetSalesPerformanceReport: async function () {
        return axios.get(`${GATEWAY_URL}/new-sales-performance`)
        .then((response) => {
            return response.data;
        });
    },
    getLiveSalesReport: async function () {
        return axios.get(`${GATEWAY_URL}/live-sales`)
        .then((response) => {
            return response.data;
        });
    },
    newGetLiveSalesReport: async function () {
        return axios.get(`${GATEWAY_URL}/new-live-sales`)
        .then((response) => {
            return response.data;
        });
    },
    getStockReportReport: async function () {
        return axios.get(`${GATEWAY_URL}/stock-report`)
        .then((response) => {
            return response.data;
        });
    },
    newGetStockReportReport: async function () {
        return axios.get(`${GATEWAY_URL}/new-stock-report`)
        .then((response) => {
            return response.data;
        });
    },
    getBonibiReport: async function () {
        return axios.get(`${GATEWAY_URL}/bonibi-report`)
        .then((response) => {
            return response.data;
        });
    },
    newGetBonibiReport: async function () {
        return axios.get(`${GATEWAY_URL}/new-bonibi-report`)
        .then((response) => {
            return response.data;
        });
    },
    getSalesPerformanceReportPm: async function () {
        return axios.get(`${GATEWAY_URL}/sales-performance-pm`)
        .then((response) => {
            return response.data;
        });
    },
    newGetSalesPerformanceReportPm: async function () {
        return axios.get(`${GATEWAY_URL}/new-sales-performance-pm`)
        .then((response) => {
            return response.data;
        });
    },
    demoGetLiveSalesReport: async function () {
        return axios.get(`${GATEWAY_URL}/demo-live-sales`)
        .then((response) => {
            return response.data;
        });
    },
    demoGetStockReport: async function () {
        return axios.get(`${GATEWAY_URL}/demo-stock-report`)
        .then((response) => {
            return response.data;
        });
    },
    demoGetSalesPerformanceReport: async function () {
        return axios.get(`${GATEWAY_URL}/demo-sales-performance`)
        .then((response) => {
            return response.data;
        });
    }
}

export default powerBiservice;